import { AlmeUIResponse} from '../../types/response';
import { Store } from "redux";
import * as Actions from './actions/actions';
import {DefaultSettings} from '../../settings/settings-util'
import {AlmeResponseV5} from '@alme/types/response/AlmeResponse';
import {ResponseAction} from '@alme/types/response/ResponseAction';
import ResponseActionHandler from '../../types/response-action-handler';
import { AlmeState } from "../../wireup/AlmeState";
import {Message} from "../../types/response";
import { Console } from 'console';
import Reducer from './reducers/index';
interface LaunchMessageProcessStateResponseAction extends ResponseAction{
    Disabled: string;
}

export default class ResponseHandlerLaunchMessageProcess{
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;
    }

    getReducer() {
        return Reducer;
    }

    doesHandle(response) {
        return response.messageType === this._settings.messageConstants.converseRequest ||
            response.messageType === this._settings.messageConstants.requestUnitRequest ||
            response.messageType === this._settings.messageConstants.appeventRequest ||
            response.messageType === this._settings.messageConstants.getHistoryRequest;
    }

    process(message) {
        if (!this.doesHandle(message)) return message;
        if (this.isArrayOfMessages(message)) return this.handleArrayOfMessages(message);

        message.response = this.processResponse(message.response);

        return message;
    }

    processResponse(response) {
        if (!response) return response;
        const responseActions = response?.responseActions?.filter(action => action.Name === "SuppressPoNVariable");
        if(responseActions?.length > 0)
        {
            this._store?.dispatch(Actions.setResponseAction(responseActions[0].LaunchPointVariableName));
        }
        return response;
    }

    isArrayOfMessages( message ) {
        return Array.isArray(message.response);
    }

    handleArrayOfMessages( message ) {
        for (let i = 0, len = message.response.length; i < len; i++) {
            message.response[i] = this.processResponse(message.response[i]);
        }
        return message;
    }

}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-launch-message-process/response-handler-launch-message-process.ts